
import DownloadPreview from '../downloadPreview.vue';
import { language } from '@/common/storage';

export default {
  props: {
    packagePreview: {
      type: Object
    },
    resStatus: {
      type: Object,
      default: function _default() {
        return {
          audio: 1,
          image: 0,
          video: 0
        };
      }
    },
    selectedChannelIds: {
      type: String
    },
    packSelectStatus: {
      type: Boolean,
      require: true
    },
    packQuality: {
      type: String,
      require: true
    },
    cannotPreviewTips: {
      type: String
    },
    disabledQualityType: {
      type: Boolean,
      require: false
    }
  },
  components: {
    DownloadPreview: DownloadPreview
  },
  data: function data() {
    return {
      lang: language.get(),
      downloadPreviewDialog: {
        visible: false
      },
      qualityTypeOptions: [{
        label: this.$t('playTurbo.common.downloadVersionDialog.package.zipType.normal'),
        value: 0
      }, {
        label: this.$t('playTurbo.common.downloadVersionDialog.package.zipType.custom'),
        value: 1
      }],
      settingOptions: [{
        label: '100%',
        value: 5,
        quality: 0
      }, {
        label: '90%',
        value: 4,
        quality: 1
      }, {
        label: '80%',
        value: 3,
        quality: 2
      }, {
        label: '70%',
        value: 2,
        quality: 3
      }, {
        label: '60%',
        value: 1,
        quality: 4
      }, {
        label: '50%',
        value: 0,
        quality: 5
      }],
      formValue: {
        qualityType: 0,
        quality: 5,
        image: 3,
        video: 3,
        audio: 3
      }
    };
  },
  mounted: function mounted() {},

  watch: {},
  computed: {
    formItem: function formItem() {
      return [{
        visible: this.formValue.qualityType === 0,
        label: this.$t('playTurbo.common.downloadVersionDialog.package.qualityLabel.normal'),
        prop: 'quality'
      }, {
        visible: this.formValue.qualityType === 1 && this.resStatus['image'],
        label: this.$t('playTurbo.common.downloadVersionDialog.package.qualityLabel.image'),
        prop: 'image'
      }, {
        visible: this.formValue.qualityType === 1 && this.resStatus['video'],
        label: this.$t('playTurbo.common.downloadVersionDialog.package.qualityLabel.video'),
        prop: 'video'
      }, {
        visible: this.formValue.qualityType === 1 && this.resStatus['audio'],
        label: this.$t('playTurbo.common.downloadVersionDialog.package.qualityLabel.audio'),
        prop: 'audio'
      }];
    },
    innerFormItem: function innerFormItem() {
      return this.formItem.filter(function (item) {
        return item.visible;
      });
    },
    currentQuality: function currentQuality() {
      return this.getQuality();
    },
    canPreview: function canPreview() {
      return !this.packagePreview.loading && this.packagePreview.url;
    },
    canSetQuality: function canSetQuality() {
      return !this.packagePreview.loading;
    },
    canApplyQuality: function canApplyQuality() {
      return this.packQuality !== this.currentQuality && this.canSetQuality;
    }
  },
  methods: {
    handleApply: function handleApply() {
      if (!this.selectedChannelIds) {
        this.$message({
          type: 'warning',
          message: this.$t('playTurbo.common.downloadVersionDialog.package.downloadNotice')
        });
        return;
      }
      this.$emit('updateQuality', this.getQuality());
    },
    getQuality: function getQuality() {
      var _this = this;

      // 通过配置value的值，交换接口使用quality
      var exchangeQuality = function exchangeQuality(val) {
        var item = _this.settingOptions.filter(function (item) {
          return item.value === val;
        });
        return item && item.length ? item[0].quality : val;
      };
      if (this.formValue.qualityType === 1) {
        return [exchangeQuality(this.formValue.image), exchangeQuality(this.formValue.video), exchangeQuality(this.formValue.audio)].join(); // 质量字段格式：图片质量，视频质量，音频质量
      }
      var temp = [];
      for (var i = 0; i < 3; i++) {
        temp.push(exchangeQuality(this.formValue.quality));
      }
      return temp.join(); // 质量字段格式：图片质量，视频质量，音频质量
    },
    formatQuality: function formatQuality(val) {
      var item = this.settingOptions.filter(function (item) {
        return item.value === val;
      })[0];
      if (item) {
        return item.label;
      }
      return '';
    },
    handleClose: function handleClose() {
      this.downloadPreviewDialog.visible = false;
    },
    handlePackagePreview: function handlePackagePreview() {
      this.downloadPreviewDialog.visible = true;
    },
    handlePackChangeQuality: function handlePackChangeQuality(bool) {
      this.$emit('updatePackChange', bool);
    }
  }
};